import { Controller } from '@hotwired/stimulus'
import { DAY, SELECT_NOTIFICATION_GROUPS, trans } from '../../translator'
import escapeHtml from '../../utils/sanitize'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'

import moment from 'moment-timezone'
global.moment = moment
require('tempusdominus-bootstrap-4')
$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'far fa-arrow-up',
    down: 'far fa-arrow-down',
    previous: 'far fa-chevron-left',
    next: 'far fa-chevron-right',
    today: 'far fa-calendar-check-o',
    clear: 'far fa-trash',
    close: 'far fa-check'
  }
})

const teamsDropdownConfig = {
  placeholder: trans(SELECT_NOTIFICATION_GROUPS, {}, 'logs'),
  fullTextSearch: true,
  match: 'text',
  onAdd: function (addedValue, addedText, addedChoice) {
    if (addedValue === 'ALL') {
      $(this).parent().find('a').each(function () {
        if ($(this).attr('data-value') !== 'ALL') {
          $(this).find('i').click()
        }
      })

      $(this).parent().find('.item').each(function (e) {
        $(this).addClass('disabled')
      })
    }
  },
  onRemove: function (removedValue, removedText, removedChoice) {
    if (removedValue === 'ALL') {
      $(this).parent().find('.item.disabled').each(function (e) {
        $(this).removeClass('disabled')
      })
    }
  }
}

export default class extends Controller {
  static values = {
    logStartsAt: { type: String, default: null },
    logTimezone: { type: String, default: null },
    numberOfDays: { type: Number, default: 1 },
    isApplyToAllDays: { type: Boolean, default: true },
    formPrefix: { type: String, default: 'log[logChecklists]' }
  }

  static targets = [
    'checklists', 'checklistName', 'checklistTaskCount', 'checklistTemplate', 'dateDropdown', 'createAtDropdown'
  ]

  connect () {
    this.nextChecklistIndex = document.querySelectorAll('.checklist').length

    document.querySelectorAll('.checklist .teams').forEach((checklistNotificationDropdown) => {
      $(checklistNotificationDropdown).dropdown(teamsDropdownConfig)
    })

    this.dateDropdownTargets.forEach(container => this.setupDateDropdown(container))
    this.createAtDropdownTargets.forEach(container => this.setupCreateAtDropdown(container))

    this.addToDropdownsHandler = this.addToDropdowns.bind(this)
    this.removeFromDropdownsHandler = this.removeFromDropdowns.bind(this)
    this.updateNumberOfDaysHandler = (event) => {
      this.logStartsAtValue = event.detail.startsAt ? event.detail.startsAt : null
      if (event.detail.timezone) {
        this.logTimezoneValue = event.detail.timezone
      }
      this.updateNumberOfDays(event.detail.numberOfDays)
    }
    this.isApplyToAllDaysHandler = (event) => {
      this.isApplyToAllDaysValue = event.detail.isApplyToAllDays
      this.updateNumberOfDays(this.numberOfDaysValue)
    }

    this.triggerConfiguredHandler = (event) => this.addTriggerToAnchorDropdowns(event.detail.triggerId, event.detail.triggerName, event.detail.day || '0')
    this.triggerClearedHandler = (event) => this.removeTriggerFromAnchorDropdowns(event.detail.triggerId)
    this.triggerTimesUpdatedHandler = () => this.refreshAllAnchorSubTexts()

    document.addEventListener('markers:marker:added', this.addToDropdownsHandler)
    document.addEventListener('markers:marker:removed', this.removeFromDropdownsHandler)
    document.addEventListener('markers:date-range:updated', this.updateNumberOfDaysHandler)
    document.addEventListener('markers:all-days-mode:updated', this.isApplyToAllDaysHandler)
    document.addEventListener('triggers:trigger:configured', this.triggerConfiguredHandler)
    document.addEventListener('triggers:trigger:cleared', this.triggerClearedHandler)
    document.addEventListener('triggers:times:updated', this.triggerTimesUpdatedHandler)
  }

  disconnect () {
    document.removeEventListener('markers:marker:added', this.addToDropdownsHandler)
    document.removeEventListener('markers:marker:removed', this.removeFromDropdownsHandler)
    document.removeEventListener('markers:date-range:updated', this.updateNumberOfDaysHandler)
    document.removeEventListener('markers:all-days-mode:updated', this.isApplyToAllDaysHandler)
    document.removeEventListener('triggers:trigger:configured', this.triggerConfiguredHandler)
    document.removeEventListener('triggers:trigger:cleared', this.triggerClearedHandler)
    document.removeEventListener('triggers:times:updated', this.triggerTimesUpdatedHandler)
  }

  formatMins (mins) {
    /* global accountIsUseAmPm */
    const h = Math.floor(mins / 60)
    const m = mins % 60
    if (typeof accountIsUseAmPm !== 'undefined' && accountIsUseAmPm) {
      const period = h >= 12 ? 'pm' : 'am'
      const h12 = h % 12 || 12
      return `${h12}:${String(m).padStart(2, '0')} ${period}`
    }
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
  }

  formatOffset (absMins) {
    if (absMins >= 60) {
      const h = Math.floor(absMins / 60)
      const m = absMins % 60
      return m > 0 ? `${h}h ${m}min` : `${h}h`
    }
    return `${absMins} min`
  }

  updateSelectedDisplay (anchorDropdown) {
    const selectedValue = $(anchorDropdown).dropdown('get value')
    const textEl = Array.from(anchorDropdown.children).find(el => el.classList.contains('text'))
    if (!textEl || !selectedValue) return

    const menu = anchorDropdown.querySelector('.menu')
    const selectedItem = menu ? menu.querySelector(`.item[data-value="${selectedValue}"]`) : null
    if (!selectedItem) return

    const anchorType = selectedItem.dataset.anchorType
    const itemName = selectedItem.querySelector('.checklist-anchor-item-name')?.textContent?.trim() ||
      selectedItem.dataset.text || ''
    let subText = ''
    if (anchorType === 'marker') {
      subText = this.getMarkerSubText(document.querySelector(`.marker-row[data-marker-id="${selectedValue}"]`))
    } else if (anchorType === 'trigger') {
      subText = this.getTriggerSubText(selectedValue)
    }

    if (subText) {
      textEl.innerHTML = `${escapeHtml(itemName)}<span class="checklist-anchor-selected-sub">${escapeHtml(subText)}</span>`
    } else {
      textEl.textContent = itemName
    }
    textEl.classList.remove('default')
  }

  refreshAllAnchorSubTexts () {
    this.createAtDropdownTargets.forEach(container => {
      if (container.classList.contains('template')) return
      const anchorDropdown = container.querySelector('.checklist-anchor-dropdown')
      if (!anchorDropdown) return
      const menu = anchorDropdown.querySelector('.menu')
      if (menu) this.refreshAnchorSubTexts(menu)
    })
  }

  refreshAnchorSubTexts (menu) {
    Array.from(menu.querySelectorAll('.item[data-anchor-type]')).forEach(item => {
      const anchorType = item.dataset.anchorType
      const value = item.dataset.value
      if (!value) return

      let subText = ''
      if (anchorType === 'marker') {
        const markerRow = document.querySelector(`.marker-row[data-marker-id="${value}"]`)
        subText = this.getMarkerSubText(markerRow)
      } else if (anchorType === 'trigger') {
        subText = this.getTriggerSubText(value)
      }

      let subSpan = item.querySelector('.checklist-anchor-item-sub')
      if (subText) {
        if (!subSpan) {
          subSpan = document.createElement('span')
          subSpan.classList.add('checklist-anchor-item-sub')
          item.appendChild(subSpan)
        }
        subSpan.textContent = subText
      } else if (subSpan) {
        subSpan.remove()
      }
    })

    this.sortTriggerItemsInMenu(menu)

    // Also refresh the selected-value display for this dropdown
    const anchorDropdown = menu.closest('.checklist-anchor-dropdown')
    if (anchorDropdown) this.updateSelectedDisplay(anchorDropdown)
  }

  getMarkerSubText (markerRow) {
    if (!markerRow) return ''

    if (markerRow.dataset.isAbsolute === 'true') {
      const mins = parseInt(markerRow.dataset.occursAtInMinutes)
      if (isNaN(mins)) return ''
      return this.formatMins(mins)
    }

    if (markerRow.dataset.isRelative === 'true') {
      const raw = parseInt(markerRow.dataset.relativeOffsetInMinutes)
      const absMins = isNaN(raw) ? 0 : Math.abs(raw)
      const direction = markerRow.dataset.relativeMarkerType === 'before' ? 'before' : 'after'
      const offsetText = this.formatOffset(absMins)
      const relId = markerRow.dataset.relativeMarkerId
      if (relId) {
        const relRow = document.querySelector(`.marker-row[data-marker-id="${relId}"]`)
        if (relRow) {
          const relSelect = relRow.querySelector('.log-event-select')
          const relName = relSelect ? $(relSelect).dropdown('get text') : ''
          if (relName) return `${offsetText} ${direction} ${relName}`
        }
      }
      return absMins > 0 ? `${offsetText} ${direction}` : ''
    }

    return ''
  }

  getTriggerSubText (triggerId) {
    const row = document.querySelector(`.trigger-row[data-trigger-id="${triggerId}"]`)
    if (!row) return ''

    const direction = row.dataset.triggerDirection
    if (!direction || direction === 'at') {
      const mins = parseInt(row.querySelector('.trigger-time-input')?.value)
      if (isNaN(mins)) return ''
      return this.formatMins(mins)
    }

    // before / after — read days/hours/minutes inputs
    const days = parseInt(row.querySelector('.trigger-days-input')?.value) || 0
    const hours = parseInt(row.querySelector('.trigger-hours-input')?.value) || 0
    const minutes = parseInt(row.querySelector('.trigger-minutes-input')?.value) || 0
    const absMins = days * 1440 + hours * 60 + minutes
    const offsetText = this.formatOffset(absMins)

    const relInput = row.querySelector('.trigger-relative-input')
    const relTriggerId = relInput ? relInput.value : null
    if (relTriggerId) {
      const relRow = document.querySelector(`.trigger-row[data-trigger-id="${relTriggerId}"]`)
      if (relRow) {
        const relItem = relRow.querySelector(`.trigger-select .menu .item[data-value="${relTriggerId}"]`)
        const relName = relItem ? relItem.textContent.trim() : ''
        if (relName) return `${offsetText} ${direction} ${relName}`
      }
    }

    const relMarkerInput = row.querySelector('.trigger-relative-event-marker-input')
    const relEventMarkerId = relMarkerInput ? relMarkerInput.value : null
    if (relEventMarkerId) {
      const markerRow = document.querySelector(`.marker-row[data-log-marker-id="${relEventMarkerId}"]`)
      const markerName = markerRow ? markerRow.dataset.markerName : ''
      if (markerName) return `${offsetText} ${direction} ${markerName}`
    }

    return absMins > 0 ? `${offsetText} ${direction}` : ''
  }

  sortTriggerItemsInMenu (menu) {
    if (!menu) return
    const triggerItems = Array.from(menu.querySelectorAll('.item[data-anchor-type="trigger"]'))
    if (triggerItems.length < 2) return

    const occursAt = (item) => {
      const row = document.querySelector(`.trigger-row[data-trigger-id="${item.dataset.value}"]`)
      const mins = row ? parseInt(row.querySelector('.trigger-time-input')?.value) : NaN
      return isNaN(mins) ? Number.POSITIVE_INFINITY : mins
    }

    // Trigger items always live at the end of the menu (after any marker section and
    // the trigger header), so re-appending them in time order preserves the layout.
    triggerItems
      .sort((a, b) => occursAt(a) - occursAt(b))
      .forEach(item => menu.appendChild(item))
  }

  addTriggerToAnchorDropdowns (triggerId, triggerName, day = '0') {
    if (!triggerId || !triggerName) return
    const triggerDay = parseInt(day) || 0
    this.createAtDropdownTargets.forEach(container => {
      const checklist = container.closest('.card') || container.closest('.d-none')
      const dateDropdownContainer = checklist ? checklist.querySelector('[data-log-checklists-target="dateDropdown"]') : null
      const dateDropdownEl = dateDropdownContainer ? dateDropdownContainer.querySelector('.ui.dropdown') : null
      const selectedDay = dateDropdownEl ? parseInt($(dateDropdownEl).dropdown('get value')) || 0 : 0
      const shouldShow = this.isApplyToAllDaysValue || triggerDay === selectedDay
      if (!shouldShow) return

      const anchorDropdown = container.querySelector('.checklist-anchor-dropdown')
      if (!anchorDropdown) return
      const menu = anchorDropdown.querySelector('.menu')
      if (!menu || menu.querySelector(`.item[data-value="${triggerId}"][data-anchor-type="trigger"]`)) return

      const item = document.createElement('div')
      item.classList.add('item')
      item.dataset.value = triggerId
      item.dataset.text = triggerName
      item.dataset.anchorType = 'trigger'
      item.dataset.triggerDay = String(triggerDay)
      const subText = this.getTriggerSubText(triggerId)
      item.innerHTML = `<span class="checklist-anchor-item-name">${escapeHtml(triggerName)}</span>${subText ? `<span class="checklist-anchor-item-sub">${escapeHtml(subText)}</span>` : ''}`
      menu.appendChild(item)

      const triggerHeader = menu.querySelector('.checklist-trigger-header')
      if (triggerHeader) triggerHeader.classList.remove('d-none')

      const hasMarkers = !!menu.querySelector('.item[data-anchor-type="marker"]')
      const divider = menu.querySelector('.checklist-anchor-divider')
      if (divider && hasMarkers) divider.classList.remove('d-none')

      this.sortTriggerItemsInMenu(menu)

      $(anchorDropdown).dropdown('refresh')
    })
  }

  removeTriggerFromAnchorDropdowns (triggerId) {
    this.createAtDropdownTargets.forEach(container => {
      const anchorDropdown = container.querySelector('.checklist-anchor-dropdown')
      if (!anchorDropdown) return
      const menu = anchorDropdown.querySelector('.menu')
      if (!menu) return
      const item = menu.querySelector(`.item[data-value="${triggerId}"][data-anchor-type="trigger"]`)
      if (!item) return

      if ($(anchorDropdown).dropdown('get value') === triggerId) {
        $(anchorDropdown).dropdown('clear')
        const markerInput = container.querySelector('.checklist-create-at-marker')
        const triggerInput = container.querySelector('.checklist-create-at-trigger')
        if (markerInput) markerInput.value = ''
        if (triggerInput) triggerInput.value = ''
      }

      item.remove()

      const hasTriggers = !!menu.querySelector('.item[data-anchor-type="trigger"]')
      const hasMarkers = !!menu.querySelector('.item[data-anchor-type="marker"]')
      const triggerHeader = menu.querySelector('.checklist-trigger-header')
      const divider = menu.querySelector('.checklist-anchor-divider')
      if (triggerHeader) triggerHeader.classList.toggle('d-none', !hasTriggers)
      if (divider) divider.classList.toggle('d-none', !hasMarkers || !hasTriggers)

      $(anchorDropdown).dropdown('refresh')
    })
  }

  setupCreateAtDropdown (container) {
    if (container.classList.contains('template')) {
      return
    }

    const anchorDropdown = container.querySelector('.checklist-anchor-dropdown')
    if (!anchorDropdown) return

    this.updateTriggerOptions(anchorDropdown)
    this.ensurePreselectedItemInMenu(anchorDropdown)

    // Read pre-selected value before Semantic UI init (it may modify data-value)
    const preselectedValue = anchorDropdown.dataset.value || ''

    const controller = this
    $(anchorDropdown).dropdown({
      forceSelection: false,
      onShow: function () {
        const menu = this.querySelector('.menu')
        if (menu) {
          requestAnimationFrame(() => { menu.scrollTop = 0 })
          controller.refreshAnchorSubTexts(menu)
        }
      },
      onChange: (value, text, $item) => {
        const anchorType = $item ? $item.data('anchor-type') : null
        const markerInput = container.querySelector('.checklist-create-at-marker')
        const triggerInput = container.querySelector('.checklist-create-at-trigger')
        if (anchorType === 'marker') {
          if (markerInput) markerInput.value = value
          if (triggerInput) triggerInput.value = ''
        } else if (anchorType === 'trigger') {
          if (triggerInput) triggerInput.value = value
          if (markerInput) markerInput.value = ''
        } else {
          if (markerInput) markerInput.value = ''
          if (triggerInput) triggerInput.value = ''
        }
        requestAnimationFrame(() => controller.updateSelectedDisplay(anchorDropdown))
      }
    })

    // Explicitly set pre-selected value so Semantic UI reliably finds the item
    if (preselectedValue) {
      $(anchorDropdown).dropdown('set value', preselectedValue)
    }
    requestAnimationFrame(() => this.updateSelectedDisplay(anchorDropdown))
  }

  setupDateDropdown (container) {
    const dateDropdown = container.querySelector('.ui.dropdown')
    $(dateDropdown).dropdown({
      forceSelection: false,
      fullTextSearch: 'exact',
      match: 'text',
      onChange: (value) => {
        const checklist = container.closest('.card') || container.closest('.d-none')
        const markerDropdown = checklist.querySelector('[data-log-checklists-target="createAtDropdown"]')
        this.updateDropdownOptions(markerDropdown, value)
      }
    })

    this.populateDateOptions(container)

    const selectedDay = $(dateDropdown).dropdown('get value') || '0'
    const checklist = container.closest('.card')
    if (checklist) {
      const markerDropdown = checklist.querySelector('[data-log-checklists-target="createAtDropdown"]')
      this.updateDropdownOptions(markerDropdown, selectedDay)
    }
  }

  populateDateOptions (dateDropdownContainer) {
    const dateDropdown = dateDropdownContainer.querySelector('.ui.dropdown')
    const selectedDay = parseInt($(dateDropdown).dropdown('get value')) ?? 0

    if (this.numberOfDaysValue > 1) {
      dateDropdownContainer.classList.remove('d-none')
    } else {
      dateDropdownContainer.classList.add('d-none')
    }

    const dateMenu = dateDropdownContainer.querySelector('.menu')
    Array.from(dateMenu.children).forEach(option => option.remove())

    let selectedDateText = 'Day 1'
    for (let day = 0; day < this.numberOfDaysValue; day++) {
      const date = moment.utc(this.logStartsAtValue).tz(this.logTimezoneValue).add(day, 'days')
      const dateText = date.isValid()
        ? date.format(accountDateFormat.toUpperCase())
        : trans(DAY, {}, 'logs') + ' ' + (day + 1)

      if (day === selectedDay) {
        selectedDateText = dateText
      }

      const option = document.createElement('div')
      option.classList.add('item')
      option.textContent = dateText
      option.dataset.value = day
      dateMenu.appendChild(option)
    }

    $(dateDropdown).dropdown('refresh')
    $(dateDropdown).dropdown('set value', selectedDay)
    $(dateDropdown).dropdown('set text', selectedDateText)
  }

  updateNumberOfDays (numberOfDays) {
    this.numberOfDaysValue = numberOfDays

    this.dateDropdownTargets.forEach(container => {
      this.populateDateOptions(container)

      const dateDropdown = container.querySelector('.ui.dropdown')
      const selectedDay = $(dateDropdown).dropdown('get value') || '0'
      const checklist = container.closest('.card')
      if (checklist) {
        const markerDropdown = checklist.querySelector('[data-log-checklists-target="createAtDropdown"]')
        this.updateDropdownOptions(markerDropdown, selectedDay)
      }
    })
  }

  resolveDropdownElement (element) {
    if (!element) {
      return null
    }

    if (element.classList && element.classList.contains('dropdown')) {
      return element
    }

    return element.querySelector('.checklist-anchor-dropdown') || element.querySelector('.ui.dropdown')
  }

  updateTriggerOptions (anchorDropdown) {
    if (!anchorDropdown) return
    const menu = anchorDropdown.querySelector('.menu')
    if (!menu) return

    const container = anchorDropdown.closest('[data-log-checklists-target="createAtDropdown"]')
    const checklist = container ? (container.closest('.card') || container.closest('.d-none')) : null
    const dateDropdownContainer = checklist ? checklist.querySelector('[data-log-checklists-target="dateDropdown"]') : null
    const dateDropdownEl = dateDropdownContainer ? dateDropdownContainer.querySelector('.ui.dropdown') : null
    const selectedDay = dateDropdownEl ? parseInt($(dateDropdownEl).dropdown('get value')) || 0 : 0

    document.querySelectorAll('.trigger-row[data-trigger-id]').forEach(row => {
      const triggerId = row.dataset.triggerId
      if (!triggerId) return

      const dayInput = row.querySelector('.trigger-day-input')
      const triggerDay = parseInt(dayInput ? dayInput.value : '0') || 0
      const shouldShow = this.isApplyToAllDaysValue || triggerDay === selectedDay
      if (!shouldShow) return

      if (menu.querySelector(`.item[data-value="${triggerId}"][data-anchor-type="trigger"]`)) return

      const item = row.querySelector(`.trigger-select .menu .item[data-value="${triggerId}"]`)
      const triggerName = item ? item.textContent.trim() : ''
      if (!triggerName) return

      const newItem = document.createElement('div')
      newItem.classList.add('item')
      newItem.dataset.value = triggerId
      newItem.dataset.text = triggerName
      newItem.dataset.anchorType = 'trigger'
      newItem.dataset.triggerDay = String(triggerDay)
      newItem.innerHTML = `<span class="checklist-anchor-item-name">${escapeHtml(triggerName)}</span>`
      menu.appendChild(newItem)

      const triggerHeader = menu.querySelector('.checklist-trigger-header')
      if (triggerHeader) triggerHeader.classList.remove('d-none')

      const hasMarkers = !!menu.querySelector('.item[data-anchor-type="marker"]')
      const divider = menu.querySelector('.checklist-anchor-divider')
      if (divider && hasMarkers) divider.classList.remove('d-none')
    })

    this.sortTriggerItemsInMenu(menu)
  }

  ensurePreselectedItemInMenu (anchorDropdown) {
    const initialValue = anchorDropdown.dataset.value
    const anchorType = anchorDropdown.dataset.initialAnchorType
    const initialText = anchorDropdown.dataset.initialText
    if (!initialValue || !anchorType || !initialText) return

    const menu = anchorDropdown.querySelector('.menu')
    if (!menu || menu.querySelector(`.item[data-value="${initialValue}"]`)) return

    const item = document.createElement('div')
    item.classList.add('item')
    item.dataset.value = initialValue
    item.dataset.text = initialText
    item.dataset.anchorType = anchorType
    item.innerHTML = `<span class="checklist-anchor-item-name">${escapeHtml(initialText)}</span>`
    menu.appendChild(item)

    if (anchorType === 'trigger') {
      const triggerHeader = menu.querySelector('.checklist-trigger-header')
      if (triggerHeader) triggerHeader.classList.remove('d-none')
    } else if (anchorType === 'marker') {
      const markerHeader = menu.querySelector('.checklist-marker-header')
      if (markerHeader) markerHeader.classList.remove('d-none')
    }
  }

  updateDropdownOptions (dropdownElement, selectedDay) {
    const dropdown = this.resolveDropdownElement(dropdownElement)

    if (!dropdown) {
      return
    }

    if (this.isApplyToAllDaysValue) {
      selectedDay = 0
    }

    const dropdownMenu = dropdown.querySelector('.menu')
    if (!dropdownMenu) return

    // Remove marker and trigger items, re-add matching ones for selected day
    Array.from(dropdownMenu.querySelectorAll('.item[data-anchor-type="marker"]')).forEach(el => el.remove())
    Array.from(dropdownMenu.querySelectorAll('.item[data-anchor-type="trigger"]')).forEach(el => el.remove())

    const divider = dropdownMenu.querySelector('.checklist-anchor-divider')
    const markerHeader = dropdownMenu.querySelector('.checklist-marker-header')
    const insertBefore = divider || dropdownMenu.querySelector('.checklist-trigger-header')

    document.querySelectorAll(`.marker-group[data-day="${selectedDay}"] .log-event-select`).forEach((select) => {
      const value = $(select).dropdown('get value')
      const text = $(select).dropdown('get text')

      if (value !== '') {
        const markerRow = select.closest('.marker-row')
        const subText = this.getMarkerSubText(markerRow)
        const option = document.createElement('div')
        option.classList.add('item')
        option.dataset.value = value
        option.dataset.text = text
        option.dataset.anchorType = 'marker'
        option.innerHTML = `<span class="checklist-anchor-item-name">${escapeHtml(text)}</span>${subText ? `<span class="checklist-anchor-item-sub">${escapeHtml(subText)}</span>` : ''}`
        if (insertBefore) {
          dropdownMenu.insertBefore(option, insertBefore)
        } else {
          dropdownMenu.appendChild(option)
        }
      }
    })

    document.querySelectorAll('.trigger-row[data-trigger-id]').forEach(row => {
      const triggerId = row.dataset.triggerId
      if (!triggerId) return
      const dayInput = row.querySelector('.trigger-day-input')
      const triggerDay = parseInt(dayInput ? dayInput.value : '0') || 0
      const shouldShow = this.isApplyToAllDaysValue || triggerDay === parseInt(selectedDay)
      if (!shouldShow) return
      const item = row.querySelector(`.trigger-select .menu .item[data-value="${triggerId}"]`)
      const triggerName = item ? item.textContent.trim() : ''
      if (!triggerName) return
      const subText = this.getTriggerSubText(triggerId)
      const newItem = document.createElement('div')
      newItem.classList.add('item')
      newItem.dataset.value = triggerId
      newItem.dataset.text = triggerName
      newItem.dataset.anchorType = 'trigger'
      newItem.dataset.triggerDay = String(triggerDay)
      newItem.innerHTML = `<span class="checklist-anchor-item-name">${escapeHtml(triggerName)}</span>${subText ? `<span class="checklist-anchor-item-sub">${escapeHtml(subText)}</span>` : ''}`
      dropdownMenu.appendChild(newItem)
    })

    const hasMarkers = !!dropdownMenu.querySelector('.item[data-anchor-type="marker"]')
    const hasTriggers = !!dropdownMenu.querySelector('.item[data-anchor-type="trigger"]')
    const triggerHeader = dropdownMenu.querySelector('.checklist-trigger-header')
    if (markerHeader) markerHeader.classList.toggle('d-none', !hasMarkers)
    if (triggerHeader) triggerHeader.classList.toggle('d-none', !hasTriggers)
    if (divider) divider.classList.toggle('d-none', !hasMarkers || !hasTriggers)

    this.sortTriggerItemsInMenu(dropdownMenu)

    $(dropdown).dropdown('refresh')
    const selectedValue = $(dropdown).dropdown('get value')
    if (selectedValue && !dropdownMenu.querySelector(`.item[data-value="${selectedValue}"]`)) {
      $(dropdown).dropdown('clear')
      const container = dropdown.closest('[data-log-checklists-target="createAtDropdown"]')
      if (container) {
        const markerInput = container.querySelector('.checklist-create-at-marker')
        const triggerInput = container.querySelector('.checklist-create-at-trigger')
        if (markerInput) markerInput.value = ''
        if (triggerInput) triggerInput.value = ''
      }
    }
  }

  addToDropdowns (event) {
    this.dateDropdownTargets.forEach((dateDropdown) => {
      const dayDropdown = dateDropdown.querySelector('.ui.dropdown')
      const selectedDay = $(dayDropdown).dropdown('get value') || '0'

      if (event.detail.isApplyToAllDays || event.detail.day === selectedDay) {
        const checklist = dateDropdown.closest('.card') || dateDropdown.closest('.d-none')
        const dropdownContainer = checklist.querySelector('[data-log-checklists-target="createAtDropdown"]')
        const anchorDropdown = dropdownContainer ? dropdownContainer.querySelector('.checklist-anchor-dropdown') : null
        if (!anchorDropdown) return

        const dropdownMenu = anchorDropdown.querySelector('.menu')
        if (!dropdownMenu) return

        const value = event.detail.markerId
        if (!dropdownMenu.querySelector(`.item[data-value="${value}"]`)) {
          const divider = dropdownMenu.querySelector('.checklist-anchor-divider')
          const insertBefore = divider || dropdownMenu.querySelector('.checklist-trigger-header')
          const markerRow = event.detail.logMarkerId ? document.querySelector(`.marker-row[data-log-marker-id="${event.detail.logMarkerId}"]`) : null
          const subText = this.getMarkerSubText(markerRow)
          const item = document.createElement('div')
          item.classList.add('item')
          item.dataset.value = value
          item.dataset.text = event.detail.markerName
          item.dataset.anchorType = 'marker'
          item.innerHTML = `<span class="checklist-anchor-item-name">${escapeHtml(event.detail.markerName)}</span>${subText ? `<span class="checklist-anchor-item-sub">${escapeHtml(subText)}</span>` : ''}`
          if (insertBefore) {
            dropdownMenu.insertBefore(item, insertBefore)
          } else {
            dropdownMenu.appendChild(item)
          }

          const markerHeader = dropdownMenu.querySelector('.checklist-marker-header')
          const hasTriggers = !!dropdownMenu.querySelector('.item[data-anchor-type="trigger"]')
          if (markerHeader) markerHeader.classList.remove('d-none')
          if (divider && hasTriggers) divider.classList.remove('d-none')

          $(anchorDropdown).dropdown('refresh')
        }
      }
    })
  }

  removeFromDropdowns (event) {
    this.dateDropdownTargets.forEach((dateDropdown) => {
      const dayDropdown = dateDropdown.querySelector('.ui.dropdown')
      const selectedDay = $(dayDropdown).dropdown('get value') || '0'

      if (event.detail.isApplyToAllDays || event.detail.day === selectedDay) {
        const checklist = dateDropdown.closest('.card') || dateDropdown.closest('.d-none')
        const dropdownContainer = checklist.querySelector('[data-log-checklists-target="createAtDropdown"]')
        const anchorDropdown = dropdownContainer ? dropdownContainer.querySelector('.checklist-anchor-dropdown') : null
        if (!anchorDropdown) return

        const value = event.detail.markerId
        const option = anchorDropdown.querySelector(`.menu .item[data-value="${value}"]`)

        if ($(anchorDropdown).dropdown('get value') === value) {
          $(anchorDropdown).dropdown('clear')
          if (dropdownContainer) {
            const markerInput = dropdownContainer.querySelector('.checklist-create-at-marker')
            if (markerInput) markerInput.value = ''
          }
        }

        if (option) {
          option.remove()
          const dropdownMenu = anchorDropdown.querySelector('.menu')
          const hasMarkers = !!dropdownMenu.querySelector('.item[data-anchor-type="marker"]')
          const hasTriggers = !!dropdownMenu.querySelector('.item[data-anchor-type="trigger"]')
          const markerHeader = dropdownMenu.querySelector('.checklist-marker-header')
          const divider = dropdownMenu.querySelector('.checklist-anchor-divider')
          if (markerHeader) markerHeader.classList.toggle('d-none', !hasMarkers)
          if (divider) divider.classList.toggle('d-none', !hasMarkers || !hasTriggers)
          $(anchorDropdown).dropdown('refresh')
        }
      }
    })
  }

  setupModal () {
    this.checklistTaskCountTargets.forEach((target) => {
      let highestLabel = 0
      document.querySelectorAll(`.checklist[data-checklist-type-id="${target.dataset.checklistTypeId}"]`).forEach((checklist) => {
        if (parseInt(checklist.dataset.label) > highestLabel) {
          highestLabel = parseInt(checklist.dataset.label)
        }
      })
      target.dataset.currentLabel = highestLabel + 1
    })

    this.checklistTaskCountTargets.forEach((target) => {
      const checklistTypeCount = document.querySelectorAll(`.checklist[data-checklist-type-id="${target.dataset.checklistTypeId}"]`).length
      target.value = checklistTypeCount
      target.dataset.originalCount = checklistTypeCount
    })
  }

  incrementAllChecklists () {
    this.checklistTaskCountTargets.forEach((target) => {
      target.value = Math.max(1, parseInt(target.value))
    })
  }

  addChecklists () {
    this.checklistTaskCountTargets.forEach((target) => {
      let currentLabel = parseInt(target.dataset.currentLabel)
      for (let i = parseInt(target.dataset.originalCount); i < parseInt(target.value); i++) {
        const checklistIndex = this.nextChecklistIndex++

        const newChecklist = this.checklistTemplateTarget.cloneNode(true)
        delete newChecklist.dataset.logChecklistsTarget
        newChecklist.classList.add('checklist')
        newChecklist.classList.remove('d-none')

        newChecklist.dataset.index = checklistIndex
        newChecklist.dataset.checklistTypeId = target.dataset.checklistTypeId
        newChecklist.dataset.label = currentLabel.toString()
        newChecklist.querySelector('.checklist-type-name').innerHTML = target.dataset.checklistTypeName
        const checklistTypeInput = newChecklist.querySelector('.checklist-type-id-input')
        checklistTypeInput.name = `${this.formPrefixValue}[${checklistIndex}][checklist_type]`
        checklistTypeInput.value = target.dataset.checklistTypeId

        newChecklist.querySelector('.checklist-name').value = target.dataset.checklistTypeName + (currentLabel > 1 ? ` ${currentLabel}` : '')
        newChecklist.querySelector('.checklist-name').name = `${this.formPrefixValue}[${checklistIndex}][name]`

        const teamsSelect = newChecklist.querySelector('.teams')
        $(teamsSelect).dropdown(teamsDropdownConfig)

        const dateDropdown = newChecklist.querySelector('[data-log-checklists-target="dateDropdown"]')
        dateDropdown.querySelector('.checklist-date-input').name = `${this.formPrefixValue}[${checklistIndex}][create_at_day]`
        this.setupDateDropdown(dateDropdown)

        const createAtDropdown = newChecklist.querySelector('[data-log-checklists-target="createAtDropdown"]')
        createAtDropdown.classList.remove('template')
        createAtDropdown.querySelector('.checklist-create-at-marker').name = `${this.formPrefixValue}[${checklistIndex}][create_at_marker]`
        createAtDropdown.querySelector('.checklist-create-at-trigger').name = `${this.formPrefixValue}[${checklistIndex}][create_at_trigger]`
        this.setupCreateAtDropdown(createAtDropdown)

        this.checklistsTarget.appendChild(newChecklist)

        currentLabel++
      }

      target.dataset.originalCount = target.value
    })
  }

  removeChecklist (event) {
    event.currentTarget.closest('.checklist').remove()
  }
}
